
  <!-- /RTL  -->
  <!-- preload -->
  <div class="preload preload-container">
      <div class="preload-logo">
          <div class="spinner"></div>
      </div>
  </div>
  <!-- /preload -->
  <div id="wrapper">

      <!-- Header -->

      <!-- /Header -->
      <!-- breadcrumb -->
      <div class="tf-breadcrumb">
          <div class="container">
              <div class="tf-breadcrumb-wrap d-flex justify-content-between flex-wrap align-items-center">
                  <div class="tf-breadcrumb-list">
                      <a href="#" class="text">Détails produit</a>
                      <i class="icon icon-arrow-right"></i>
                      <span class="text">{{ article?.libelle }}</span>
                  </div>
                  <div class="tf-breadcrumb-prev-next">
                      <a href="#" class="tf-breadcrumb-prev hover-tooltip center">
                          <i class="icon icon-arrow-left"></i>
                          <!-- <span class="tooltip">Cotton jersey top</span> -->
                      </a>
                      <a href="#" class="tf-breadcrumb-back hover-tooltip center">
                          <i class="icon icon-shop"></i>
                          <!-- <span class="tooltip">Back to Women</span> -->
                      </a>
                      <a href="#" class="tf-breadcrumb-next hover-tooltip center">
                          <i class="icon icon-arrow-right"></i>
                          <!-- <span class="tooltip">Cotton jersey top</span> -->
                      </a>
                  </div>
              </div>
          </div>
      </div>
      <!-- /breadcrumb -->
      <!-- default -->
      <section class="flat-spacing-4 pt_0">
          <div class="tf-main-product section-image-zoom">
              <div class="container">
                  <div class="row">
                      <div class="col-md-6">
                          <div class="tf-product-media-wrap sticky-top">
                              <div class="thumbs-slider">
                                  <div dir="ltr" class="swiper tf-product-media-thumbs other-image-zoom"
                                      data-direction="vertical">
                                      <div class="swiper-wrapper stagger-wrap">
                                          <!-- beige -->
                                          <div class="swiper-slide stagger-item" data-color="beige">
                                              <div class="item">
                                                <img [src]="article?.images[0]?.data" alt="Main image" class="img-fluid">
                                              </div>
                                          </div>

                                          <!-- black -->
                                          <div class="swiper-slide stagger-item" data-color="black">
                                              <div class="item">
                                                <img [src]="article?.images[0]?.data" alt="Main image" class="img-fluid">
                                              </div>
                                          </div>

                                          <!-- blue -->
                                          <div class="swiper-slide stagger-item" data-color="blue">
                                              <div class="item">
                                                <img [src]="article?.images[0]?.data" alt="Main image" class="img-fluid">
                                              </div>
                                          </div>


                                          <!-- white -->
                                          <div class="swiper-slide stagger-item" data-color="white">
                                              <div class="item">
                                                <img [src]="article?.images[0]?.data" alt="Main image" class="img-fluid">
                                              </div>
                                          </div>



                                      </div>
                                  </div>
                                  <div dir="ltr" class="swiper tf-product-media-main" id="gallery-swiper-started">
                                      <div class="swiper-wrapper">

                                          <div class="swiper-slide" data-color="beige">
                                              <a  target="_blank" class="item"
                                                  data-pswp-width="770px" data-pswp-height="1075px">
                                                  <img [src]="article?.images[0]?.data" alt="Main image" class="img-fluid">
                                              </a>
                                          </div>






                                      </div>
                                      <div class="swiper-button-next button-style-arrow thumbs-next"></div>
                                      <div class="swiper-button-prev button-style-arrow thumbs-prev"></div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-md-6" *ngIf="article">
                        <div class="tf-product-info-wrap position-relative">


                          <div class="tf-product-info-list other-image-zoom">
                            <div class="tf-product-info-title">
                              <h5>{{ article?.libelle }}</h5>
                            </div>

                            <div class="tf-product-info-badges">
                              <div class="badges" >Meilleure vente </div>
                              <div class="product-status-content" >
                                <i class="icon-lightning"></i>
                                <p class="fw-6">Vendu rapidement ! 56 personnes ont cet article dans leur panier.</p>
                              </div>
                            </div>

                            <div class="tf-product-info-price">
                              <!-- Prix en promotion -->
                              <div class="price-on-sale" *ngIf="article.promo !== 0">
                                {{ article.prix_final | number:'1.3-3' }} DT
                              </div>

                              <!-- Ancien prix barré -->
                              <div class="compare-at-price" *ngIf="article.promo !== 0">
                                <del>{{ article.prix_ttc | number:'1.3-3' }} DT</del>
                              </div>

                              <!-- Prix normal (pas en promo) -->
                              <div class="price-on-sale" *ngIf="article.promo === 0">
                                {{ article.prix_ttc | number:'1.3-3' }} DT
                              </div>

                              <!-- Badge de réduction -->
                              <div class="badges-on-sale" *ngIf="article.promo !== 0">
                                <span>{{ ((1 - article.prix_final / article.prix_ttc) * 100) | number:'1.0-0' }}</span>% OFF
                              </div>
                            </div>


                            <div class="tf-product-info-liveview" >
                              <div class="liveview-count">20</div>
                              <p class="fw-6">personnes consultent ceci en ce moment.</p>
                            </div>

                            <div class="tf-product-info-countdown" *ngIf="article.promo !== 0" >
                              <div class="countdown-wrap">
                                <div class="countdown-title">
                                  <i class="icon-time tf-ani-tada"></i>
                                  <p>DÉPÊCHEZ-VOUS ! LA VENTE SE TERMINE DANS :</p>
                                </div>
                                <div class="tf-countdown style-1">
                                  <!-- À connecter à une directive ou un component countdown -->

                                </div>
                              </div>
                            </div>

                            <!-- COULEURS -->
                            <div class="tf-product-info-variant-picker" *ngIf="article.details_variant && article.details_variant.length > 0">
                              <div class="variant-picker-item">
                                <div class="variant-picker-label" style="font-weight: bold;">
                                  Couleur :
                                  <span class="fw-6 variant-picker-label-value value-currentColor">{{ selectedTeinte }}</span>
                                </div>
                                <div class="variant-picker-values">
                                  <div
                                  class="teinte-item"
                                  *ngFor="let variant of article.details_variant"
                                  [style.background-color]="variant.icon_color"
                                  [ngClass]="{'selected': selectedTeinte === variant.libelle}"
                                  (click)="selectTeinte(variant)">
                                  </div>
                                </div>
                              </div>

                              <!-- TAILLES -->
                              <div class="variant-picker-item" *ngIf="article?.tailles?.length">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div class="variant-picker-label">
                                    Size: <span class="fw-6 variant-picker-label-value">m</span>
                                  </div>
                                  <a href="#find_size" data-bs-toggle="modal" class="find-size fw-6">Find your size</a>
                                </div>
                                <div class="variant-picker-values">
                                  <label
                                    class="style-text size-btn"


                                  >
                                    <p>s</p>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="stock-status mt-2 fw-bold"
                            [ngClass]="{'text-success': (article?.stock > 0 || article?.stock_arrivage > 0), 'text-danger': article?.stock <= 0}">
                         {{ (article?.stock > 0 || article?.stock_arrivage > 0) ? 'En stock' : 'STOCK Épuisé' }}
                       </div>
                            <!-- QUANTITÉ -->
                            <div class="tf-product-info-quantity">
                              <div class="quantity-title fw-6" style="font-weight: bold;">Quantité</div>
                              <div class="wg-quantity">
                                <span class="btn-quantity btn-decrease"   (click)="decreaseQuantity(article)" >-</span>
                                <input
                                class="product_count_item input-number"
                                type="text"
                                [(ngModel)]="quantity"
                                min="1"
                                maxlength="12">
                                <span class="btn-quantity btn-increase"  (click)="increaseQuantity(article)"
                               >+</span>
                              </div>
                            </div>

                            <!-- BOUTONS -->
                            <div class="tf-product-info-buy-button">
                              <form class="">
                                  <a  (click)="addToCart($event,article, quantity)"
                                      class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn-add-to-cart"><span>Ajouter au panier -&nbsp;</span><span class="tf-qty-price total-price">
                                            {{ (article.promo !== 0 ? article.prix_final : article.prix_ttc) * quantity | number:'1.3-3' }} DT
                                          </span>
                                          </a>
                                  <a href="javascript:void(0);"
                                      class="tf-product-btn-wishlist hover-tooltip box-icon bg_white wishlist btn-icon-action">
                                      <span class="icon icon-heart"></span>
                                      <span class="tooltip">Favoris</span>
                                      <span class="icon icon-delete"></span>
                                  </a>

                                  <!-- <div class="w-100">
                                      <a href="#" class="btns-full">Acheter maintenant <img
                                              src="assets/images/payments/paypal.png" alt=""></a>
                                      <a href="#" class="payment-more-option">More payment options</a>
                                  </div> -->
                              </form>
                          </div>



                          </div>
                        </div>
                      </div>

                  </div>
              </div>
          </div>
          <!-- <div class="tf-sticky-btn-atc">
              <div class="container">
                  <div class="tf-height-observer w-100 d-flex align-items-center">
                      <div class="tf-sticky-atc-product d-flex align-items-center">
                          <div class="tf-sticky-atc-img">
                            <img [src]="article?.images[0]?.data" alt="Main image" class="img-fluid">
                          </div>
                          <div class="tf-sticky-atc-title fw-5 d-xl-block d-none">{{ article?.libelle }}</div>
                      </div>
                      <div class="tf-sticky-atc-infos">
                          <form class="">
                              <div class="tf-sticky-atc-variant-price text-center">
                                  <select class="tf-select">
                                      <option selected="selected">Beige / S - $8.00</option>
                                      <option>Beige / M - $8.00</option>
                                      <option>Beige / L - $8.00</option>
                                      <option>Beige / XL - $8.00</option>
                                      <option>Black / S - $8.00</option>
                                      <option>Black / M - $8.00</option>
                                      <option>Black / L - $8.00</option>
                                      <option>Black / XL - $8.00</option>
                                      <option>Blue / S - $8.00</option>
                                      <option>Blue / M - $8.00</option>
                                      <option>Blue / L - $8.00</option>
                                      <option>Blue / XL - $8.00</option>
                                      <option>White / S - $8.00</option>
                                      <option>White / M - $8.00</option>
                                      <option>White / L - $8.00</option>
                                      <option>White / XL - $8.00</option>
                                  </select>
                              </div>
                              <div class="tf-sticky-atc-btns">
                                  <div class="tf-product-info-quantity">
                                      <div class="wg-quantity">
                                          <span class="btn-quantity minus-btn">-</span>
                                          <input type="text" name="number" value="1">
                                          <span class="btn-quantity plus-btn">+</span>
                                      </div>
                                  </div>
                                  <a href="javascript:void(0);"
                                      class="tf-btn btn-fill radius-3 justify-content-center fw-6 fs-14 flex-grow-1 animate-hover-btn btn-add-to-cart"><span>Add
                                          to cart</span></a>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div> -->
      </section>
      <!-- /default -->
      <!-- tabs -->
      <section class="flat-spacing-17 pt_0">
          <div class="container">
              <div class="row">
                  <div class="col-12">
                      <div class="widget-tabs style-has-border">
                          <ul class="widget-menu-tab">
                              <li class="item-title active">
                                  <span class="inner">Description</span>
                              </li>
                              <li class="item-title">
                                  <span class="inner">Additional Information</span>
                              </li>
                              <li class="item-title">
                                  <span class="inner">Review</span>
                              </li>
                              <li class="item-title">
                                  <span class="inner">Shipping</span>
                              </li>
                              <li class="item-title">
                                  <span class="inner">Return Policies</span>
                              </li>
                          </ul>
                          <div class="widget-content-tab">
                              <div class="widget-content-inner active">
                                  <div class="">
                                      <p class="mb_30">
                                        {{ article?.description}}
                                        {{article?.plus_details}}
                                      </p>

                                  </div>
                              </div>
                              <div class="widget-content-inner">
                                  <table class="tf-pr-attrs">
                                      <tbody>
                                          <tr class="tf-attr-pa-color">
                                              <th class="tf-attr-label">Couleur</th>
                                              <td class="tf-attr-value">
                                                  <p>{{ selectedTeinte }}</p>
                                              </td>
                                          </tr>
                                          <tr class="tf-attr-pa-size">
                                              <th class="tf-attr-label">Size</th>
                                              <td class="tf-attr-value">
                                                  <p>S, M, L, XL</p>
                                              </td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                              <div class="widget-content-inner">
                                  <div class="tab-reviews write-cancel-review-wrap">
                                      <div class="tab-reviews-heading">
                                          <div class="top">
                                              <div class="text-center">
                                                  <h1 class="number fw-6">4.8</h1>
                                                  <div class="list-star">
                                                      <i class="icon icon-star"></i>
                                                      <i class="icon icon-star"></i>
                                                      <i class="icon icon-star"></i>
                                                      <i class="icon icon-star"></i>
                                                      <i class="icon icon-star"></i>
                                                  </div>
                                                  <p>(168 Ratings)</p>
                                              </div>
                                              <div class="rating-score">
                                                  <div class="item">
                                                      <div class="number-1 text-caption-1">5</div>
                                                      <i class="icon icon-star"></i>
                                                      <div class="line-bg">
                                                          <div style="width: 94.67%;"></div>
                                                      </div>
                                                      <div class="number-2 text-caption-1">59</div>
                                                  </div>
                                                  <div class="item">
                                                      <div class="number-1 text-caption-1">4</div>
                                                      <i class="icon icon-star"></i>
                                                      <div class="line-bg">
                                                          <div style="width: 60%;"></div>
                                                      </div>
                                                      <div class="number-2 text-caption-1">46</div>
                                                  </div>
                                                  <div class="item">
                                                      <div class="number-1 text-caption-1">3</div>
                                                      <i class="icon icon-star"></i>
                                                      <div class="line-bg">
                                                          <div style="width: 0%;"></div>
                                                      </div>
                                                      <div class="number-2 text-caption-1">0</div>
                                                  </div>
                                                  <div class="item">
                                                      <div class="number-1 text-caption-1">2</div>
                                                      <i class="icon icon-star"></i>
                                                      <div class="line-bg">
                                                          <div style="width: 0%;"></div>
                                                      </div>
                                                      <div class="number-2 text-caption-1">0</div>
                                                  </div>
                                                  <div class="item">
                                                      <div class="number-1 text-caption-1">1</div>
                                                      <i class="icon icon-star"></i>
                                                      <div class="line-bg">
                                                          <div style="width: 0%;"></div>
                                                      </div>
                                                      <div class="number-2 text-caption-1">0</div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div>
                                              <div
                                                  class="tf-btn btn-outline-dark fw-6 btn-comment-review btn-cancel-review">
                                                  Cancel Review</div>
                                              <div
                                                  class="tf-btn btn-outline-dark fw-6 btn-comment-review btn-write-review">
                                                  Write a review</div>
                                          </div>
                                      </div>
                                      <div class="reply-comment cancel-review-wrap">
                                          <div
                                              class="d-flex mb_24 gap-20 align-items-center justify-content-between flex-wrap">
                                              <h5 class="">03 Comments</h5>
                                              <div class="d-flex align-items-center gap-12">
                                                  <div class="text-caption-1">Sort by:</div>
                                                  <div class="tf-dropdown-sort" data-bs-toggle="dropdown">
                                                      <div class="btn-select">
                                                          <span class="text-sort-value">Most Recent</span>
                                                          <span class="icon icon-arrow-down"></span>
                                                      </div>
                                                      <div class="dropdown-menu">
                                                          <div class="select-item active">
                                                              <span class="text-value-item">Most Recent</span>
                                                          </div>
                                                          <div class="select-item">
                                                              <span class="text-value-item">Oldest</span>
                                                          </div>
                                                          <div class="select-item">
                                                              <span class="text-value-item">Most Popular</span>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                          <div class="reply-comment-wrap">
                                              <div class="reply-comment-item">
                                                  <div class="user">
                                                      <div class="image">
                                                          <img src="assets/images/collections/collection-circle-9.jpg"
                                                              alt="">
                                                      </div>
                                                      <div>
                                                          <h6>
                                                              <a href="#" class="link">Superb quality apparel that
                                                                  exceeds expectations</a>
                                                          </h6>
                                                          <div class="day text_black-2">1 days ago</div>
                                                      </div>
                                                  </div>
                                                  <p class="text_black-2">Great theme - we were looking for a theme
                                                      with lots of built in features and flexibility and this was
                                                      perfect. We expected to need to employ a developer to add a few
                                                      finishing touches. But we actually managed to do everything
                                                      ourselves. We did have one small query and the support given was
                                                      swift and helpful.</p>
                                              </div>
                                              <div class="reply-comment-item type-reply">
                                                  <div class="user">
                                                      <div class="image">
                                                          <img src="assets/images/collections/collection-circle-10.jpg"
                                                              alt="">
                                                      </div>
                                                      <div>
                                                          <h6>
                                                              <a href="#" class="link">Reply from Modave</a>
                                                          </h6>
                                                          <div class="day text_black-2">1 days ago</div>
                                                      </div>
                                                  </div>
                                                  <p class="text_black-2">We love to hear it! Part of what we love
                                                      most about Modave is how much it empowers store owners like
                                                      yourself to build a beautiful website without having to hire a
                                                      developer :) Thank you for this fantastic review!</p>
                                              </div>
                                              <div class="reply-comment-item">
                                                  <div class="user">
                                                      <div class="image">
                                                          <img src="assets/images/collections/collection-circle-9.jpg"
                                                              alt="">
                                                      </div>
                                                      <div>
                                                          <h6>
                                                              <a href="#" class="link">Superb quality apparel that
                                                                  exceeds expectations</a>
                                                          </h6>
                                                          <div class="day text_black-2">1 days ago </div>
                                                      </div>
                                                  </div>
                                                  <p class="text_black-2">Great theme - we were looking for a theme
                                                      with lots of built in features and flexibility and this was
                                                      perfect. We expected to need to employ a developer to add a few
                                                      finishing touches. But we actually managed to do everything
                                                      ourselves. We did have one small query and the support given was
                                                      swift and helpful.</p>
                                              </div>
                                          </div>
                                      </div>
                                      <form class="form-write-review write-review-wrap">
                                          <div class="heading">
                                              <h5>Write a review:</h5>
                                              <div class="list-rating-check">
                                                  <input type="radio" id="star5" name="rate" value="5" />
                                                  <label for="star5" title="text"></label>
                                                  <input type="radio" id="star4" name="rate" value="4" />
                                                  <label for="star4" title="text"></label>
                                                  <input type="radio" id="star3" name="rate" value="3" />
                                                  <label for="star3" title="text"></label>
                                                  <input type="radio" id="star2" name="rate" value="2" />
                                                  <label for="star2" title="text"></label>
                                                  <input type="radio" id="star1" name="rate" value="1" />
                                                  <label for="star1" title="text"></label>
                                              </div>
                                          </div>
                                          <div class="form-content">
                                              <fieldset class="box-field">
                                                  <label class="label">Review Title</label>
                                                  <input type="text" placeholder="Give your review a title"
                                                      name="text" tabindex="2" value="" aria-required="true"
                                                      required="">
                                              </fieldset>
                                              <fieldset class="box-field">
                                                  <label class="label">Review</label>
                                                  <textarea rows="4" placeholder="Write your comment here"
                                                      tabindex="2" aria-required="true" required=""></textarea>
                                              </fieldset>
                                              <div class="box-field group-2">
                                                  <fieldset>
                                                      <input type="text" placeholder="You Name (Public)" name="text"
                                                          tabindex="2" value="" aria-required="true" required="">
                                                  </fieldset>
                                                  <fieldset>
                                                      <input type="email" placeholder="Your email (private)"
                                                          name="email" tabindex="2" value="" aria-required="true"
                                                          required="">
                                                  </fieldset>
                                              </div>
                                              <div class="box-check">
                                                  <input type="checkbox" name="availability" class="tf-check"
                                                      id="check1">
                                                  <label class="text_black-2" for="check1">Save my name, email, and
                                                      website in this browser for the next time I comment.</label>
                                              </div>
                                          </div>
                                          <div class="button-submit">
                                              <button class="tf-btn btn-fill animate-hover-btn" type="submit">Submit
                                                  Reviews</button>
                                          </div>
                                      </form>
                                  </div>
                              </div>
                              <div class="widget-content-inner">
                                  <div class="tf-page-privacy-policy">
                                      <div class="title">The Company Private Limited Policy</div>
                                      <p>The Company Private Limited and each of their respective subsidiary, parent
                                          and affiliated companies is deemed to operate this Website (“we” or “us”)
                                          recognizes that you care how information about you is used and shared. We
                                          have created this Privacy Policy to inform you what information we collect
                                          on the Website, how we use your information and the choices you have about
                                          the way your information is collected and used. Please read this Privacy
                                          Policy carefully. Your use of the Website indicates that you have read and
                                          accepted our privacy practices, as outlined in this Privacy Policy.</p>
                                      <p>Please be advised that the practices described in this Privacy Policy apply
                                          to information gathered by us or our subsidiaries, affiliates or agents: (i)
                                          through this Website, (ii) where applicable, through our Customer Service
                                          Department in connection with this Website, (iii) through information
                                          provided to us in our free standing retail stores, and (iv) through
                                          information provided to us in conjunction with marketing promotions and
                                          sweepstakes.</p>
                                      <p>We are not responsible for the content or privacy practices on any websites.
                                      </p>
                                      <p>We reserve the right, in our sole discretion, to modify, update, add to,
                                          discontinue, remove or otherwise change any portion of this Privacy Policy,
                                          in whole or in part, at any time. When we amend this Privacy Policy, we will
                                          revise the “last updated” date located at the top of this Privacy Policy.
                                      </p>
                                      <p>If you provide information to us or access or use the Website in any way
                                          after this Privacy Policy has been changed, you will be deemed to have
                                          unconditionally consented and agreed to such changes. The most current
                                          version of this Privacy Policy will be available on the Website and will
                                          supersede all previous versions of this Privacy Policy.</p>
                                      <p>If you have any questions regarding this Privacy Policy, you should contact
                                          our Customer Service Department by email at marketing@company.com</p>
                                  </div>
                              </div>
                              <div class="widget-content-inner">
                                  <ul class="d-flex justify-content-center mb_18">
                                      <li class="">
                                          <svg viewBox="0 0 40 40" width="35px" height="35px" color="#222"
                                              margin="5px">
                                              <path fill="currentColor"
                                                  d="M8.7 30.7h22.7c.3 0 .6-.2.7-.6l4-25.3c-.1-.4-.3-.7-.7-.8s-.7.2-.8.6L34 8.9l-3-1.1c-2.4-.9-5.1-.5-7.2 1-2.3 1.6-5.3 1.6-7.6 0-2.1-1.5-4.8-1.9-7.2-1L6 8.9l-.7-4.3c0-.4-.4-.7-.7-.6-.4.1-.6.4-.6.8l4 25.3c.1.3.3.6.7.6zm.8-21.6c2-.7 4.2-.4 6 .8 1.4 1 3 1.5 4.6 1.5s3.2-.5 4.6-1.5c1.7-1.2 4-1.6 6-.8l3.3 1.2-3 19.1H9.2l-3-19.1 3.3-1.2zM32 32H8c-.4 0-.7.3-.7.7s.3.7.7.7h24c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm0 2.7H8c-.4 0-.7.3-.7.7s.3.6.7.6h24c.4 0 .7-.3.7-.7s-.3-.6-.7-.6zm-17.9-8.9c-1 0-1.8-.3-2.4-.6l.1-2.1c.6.4 1.4.6 2 .6.8 0 1.2-.4 1.2-1.3s-.4-1.3-1.3-1.3h-1.3l.2-1.9h1.1c.6 0 1-.3 1-1.3 0-.8-.4-1.2-1.1-1.2s-1.2.2-1.9.4l-.2-1.9c.7-.4 1.5-.6 2.3-.6 2 0 3 1.3 3 2.9 0 1.2-.4 1.9-1.1 2.3 1 .4 1.3 1.4 1.3 2.5.3 1.8-.6 3.5-2.9 3.5zm4-5.5c0-3.9 1.2-5.5 3.2-5.5s3.2 1.6 3.2 5.5-1.2 5.5-3.2 5.5-3.2-1.6-3.2-5.5zm4.1 0c0-2-.1-3.5-.9-3.5s-1 1.5-1 3.5.1 3.5 1 3.5c.8 0 .9-1.5.9-3.5zm4.5-1.4c-.9 0-1.5-.8-1.5-2.1s.6-2.1 1.5-2.1 1.5.8 1.5 2.1-.5 2.1-1.5 2.1zm0-.8c.4 0 .7-.5.7-1.2s-.2-1.2-.7-1.2-.7.5-.7 1.2.3 1.2.7 1.2z">
                                              </path>
                                          </svg>
                                      </li>
                                      <li class="">
                                          <svg viewBox="0 0 40 40" width="35px" height="35px" color="#222"
                                              margin="5px">
                                              <path fill="currentColor"
                                                  d="M36.7 31.1l-2.8-1.3-4.7-9.1 7.5-3.5c.4-.2.6-.6.4-1s-.6-.5-1-.4l-7.5 3.5-7.8-15c-.3-.5-1.1-.5-1.4 0l-7.8 15L4 15.9c-.4-.2-.8 0-1 .4s0 .8.4 1l7.5 3.5-4.7 9.1-2.8 1.3c-.4.2-.6.6-.4 1 .1.3.4.4.7.4.1 0 .2 0 .3-.1l1-.4-1.5 2.8c-.1.2-.1.5 0 .8.1.2.4.3.7.3h31.7c.3 0 .5-.1.7-.4.1-.2.1-.5 0-.8L35.1 32l1 .4c.1 0 .2.1.3.1.3 0 .6-.2.7-.4.1-.3 0-.8-.4-1zm-5.1-2.3l-9.8-4.6 6-2.8 3.8 7.4zM20 6.4L27.1 20 20 23.3 12.9 20 20 6.4zm-7.8 15l6 2.8-9.8 4.6 3.8-7.4zm22.4 13.1H5.4L7.2 31 20 25l12.8 6 1.8 3.5z">
                                              </path>
                                          </svg>
                                      </li>
                                      <li class="">
                                          <svg viewBox="0 0 40 40" width="35px" height="35px" color="#222"
                                              margin="5px">
                                              <path fill="currentColor"
                                                  d="M5.9 5.9v28.2h28.2V5.9H5.9zM19.1 20l-8.3 8.3c-2-2.2-3.2-5.1-3.2-8.3s1.2-6.1 3.2-8.3l8.3 8.3zm-7.4-9.3c2.2-2 5.1-3.2 8.3-3.2s6.1 1.2 8.3 3.2L20 19.1l-8.3-8.4zM20 20.9l8.3 8.3c-2.2 2-5.1 3.2-8.3 3.2s-6.1-1.2-8.3-3.2l8.3-8.3zm.9-.9l8.3-8.3c2 2.2 3.2 5.1 3.2 8.3s-1.2 6.1-3.2 8.3L20.9 20zm8.4-10.2c-1.2-1.1-2.6-2-4.1-2.6h6.6l-2.5 2.6zm-18.6 0L8.2 7.2h6.6c-1.5.6-2.9 1.5-4.1 2.6zm-.9.9c-1.1 1.2-2 2.6-2.6 4.1V8.2l2.6 2.5zM7.2 25.2c.6 1.5 1.5 2.9 2.6 4.1l-2.6 2.6v-6.7zm3.5 5c1.2 1.1 2.6 2 4.1 2.6H8.2l2.5-2.6zm18.6 0l2.6 2.6h-6.6c1.4-.6 2.8-1.5 4-2.6zm.9-.9c1.1-1.2 2-2.6 2.6-4.1v6.6l-2.6-2.5zm2.6-14.5c-.6-1.5-1.5-2.9-2.6-4.1l2.6-2.6v6.7z">
                                              </path>
                                          </svg>
                                      </li>
                                      <li class="">
                                          <svg viewBox="0 0 40 40" width="35px" height="35px" color="#222"
                                              margin="5px">
                                              <path fill="currentColor"
                                                  d="M35.1 33.6L33.2 6.2c0-.4-.3-.7-.7-.7H13.9c-.4 0-.7.3-.7.7s.3.7.7.7h18l.7 10.5H20.8c-8.8.2-15.9 7.5-15.9 16.4 0 .4.3.7.7.7h28.9c.2 0 .4-.1.5-.2s.2-.3.2-.5v-.2h-.1zm-28.8-.5C6.7 25.3 13 19 20.8 18.9h11.9l1 14.2H6.3zm11.2-6.8c0 1.2-1 2.1-2.1 2.1s-2.1-1-2.1-2.1 1-2.1 2.1-2.1 2.1 1 2.1 2.1zm6.3 0c0 1.2-1 2.1-2.1 2.1-1.2 0-2.1-1-2.1-2.1s1-2.1 2.1-2.1 2.1 1 2.1 2.1z">
                                              </path>
                                          </svg>
                                      </li>
                                      <li class="">
                                          <svg viewBox="0 0 40 40" width="35px" height="35px" color="#222"
                                              margin="5px">
                                              <path fill="currentColor"
                                                  d="M20 33.8c7.6 0 13.8-6.2 13.8-13.8S27.6 6.2 20 6.2 6.2 12.4 6.2 20 12.4 33.8 20 33.8zm0-26.3c6.9 0 12.5 5.6 12.5 12.5S26.9 32.5 20 32.5 7.5 26.9 7.5 20 13.1 7.5 20 7.5zm-.4 15h.5c1.8 0 3-1.1 3-3.7 0-2.2-1.1-3.6-3.1-3.6h-2.6v10.6h2.2v-3.3zm0-5.2h.4c.6 0 .9.5.9 1.7 0 1.1-.3 1.7-.9 1.7h-.4v-3.4z">
                                              </path>
                                          </svg>
                                      </li>
                                      <li class="">
                                          <svg viewBox="0 0 40 40" width="35px" height="35px" color="#222"
                                              margin="5px">
                                              <path fill="currentColor"
                                                  d="M30.2 29.3c2.2-2.5 3.6-5.7 3.6-9.3s-1.4-6.8-3.6-9.3l3.6-3.6c.3-.3.3-.7 0-.9-.3-.3-.7-.3-.9 0l-3.6 3.6c-2.5-2.2-5.7-3.6-9.3-3.6s-6.8 1.4-9.3 3.6L7.1 6.2c-.3-.3-.7-.3-.9 0-.3.3-.3.7 0 .9l3.6 3.6c-2.2 2.5-3.6 5.7-3.6 9.3s1.4 6.8 3.6 9.3l-3.6 3.6c-.3.3-.3.7 0 .9.1.1.3.2.5.2s.3-.1.5-.2l3.6-3.6c2.5 2.2 5.7 3.6 9.3 3.6s6.8-1.4 9.3-3.6l3.6 3.6c.1.1.3.2.5.2s.3-.1.5-.2c.3-.3.3-.7 0-.9l-3.8-3.6z">
                                              </path>
                                          </svg>
                                      </li>
                                      <li class="">
                                          <svg viewBox="0 0 40 40" width="35px" height="35px" color="#222"
                                              margin="5px">
                                              <path fill="currentColor"
                                                  d="M34.1 34.1H5.9V5.9h28.2v28.2zM7.2 32.8h25.6V7.2H7.2v25.6zm13.5-18.3a.68.68 0 0 0-.7-.7.68.68 0 0 0-.7.7v10.9a.68.68 0 0 0 .7.7.68.68 0 0 0 .7-.7V14.5z">
                                              </path>
                                          </svg>
                                      </li>
                                  </ul>
                                  <p class="text-center text-paragraph">LT01: 70% wool, 15% polyester, 10% polyamide,
                                      5% acrylic 900 Grms/mt</p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>




  <div class="btn-sidebar-mobile d-flex start-0">
            <button class="type-hover" data-bs-toggle="offcanvas" data-bs-target="#sidebarmobile"
                aria-controls="offcanvasRight">
                <i class="icon-open"></i>
                <span class="fw-5">Voir produits similaires</span>
            </button>
        </div>
  </div>
  <div class="offcanvas offcanvas-start canvas-filter canvas-sidebar" id="sidebarmobile">
        <div class="canvas-wrapper">
            <header class="canvas-header">
                <span class="title">Produits</span>
                <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
            </header>
            <div class="canvas-body">
                <aside class="tf-shop-sidebar">

                   <div class="widget-facet">
  <div class="facet-title" data-bs-target="#sale-products" data-bs-toggle="collapse"
      aria-expanded="true" aria-controls="sale-products">
      <span>Produits similaires</span>
      <span class="icon icon-arrow-up"></span>
  </div>
  <div id="sale-products" class="collapse show">
    <div class="widget-featured-products mb_36" *ngIf="similarProducts.length > 0; else noProducts">
      <div *ngFor="let product of similarProducts" class="featured-product-item">
        <a [routerLink]="['/product-detail', product.id]" class="card-product-wrapper">
          <img class="img-product lazyload" [src]=product.images[0]?.data alt="image-feature">
        </a>
        <div class="card-product-info">
          <a [routerLink]="['/product-detail', product.id]" class="title link">{{ product.libelle }}</a>
          <span class="price">{{ product.prix_ttc | currency }}</span>
        </div>
      </div>
    </div>
    <ng-template #noProducts>
      <p>Aucun produit similaire disponible.</p>
    </ng-template>
  </div>
</div>


                    <div class="widget-facet">
                        <div class="facet-title" data-bs-target="#follow" data-bs-toggle="collapse" aria-expanded="true"
                            aria-controls="follow">
                            <span>Follow us</span>
                            <span class="icon icon-arrow-up"></span>
                        </div>
                        <div id="follow" class="collapse show">
                            <ul class="tf-social-icon d-flex gap-10">
                                <li><a href="https://www.facebook.com/Adora.Store2" class="box-icon w_34 round bg_line social-facebook"><i
                                            class="icon fs-14 icon-fb"></i></a></li>

                                <li><a href="https://www.instagram.com/adora_store_tn?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" class="box-icon w_34 round bg_line social-instagram"><i
                                            class="icon fs-14 icon-instagram"></i></a></li>

                            </ul>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </div>
  <!-- modal compare_color -->
  <div class="modal fade modalDemo tf-product-modal modal-part-content" id="compare_color">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Compare color</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-compare-color-wrapp">
                  <div class="tf-compare-color-grid">

                      <input type="checkbox" class="sr-only" id="remove-compare-color-beige-1">
                      <div class="tf-compare-color-item">
                          <div class="tf-compare-color-top">
                              <label for="remove-compare-color-beige-1" class="tf-compare-color-remove">Remove</label>
                              <img class="lazyload" data-src="assets/images/shop/products/hmgoepprod2.jpg"
                                  src="assets/images/shop/products/hmgoepprod2.jpg" alt="img-compare">
                          </div>
                          <div class="tf-compare-color-bottom">
                              <div class="tf-compare-color-color">
                                  <span class="tf-color-list-color bg-color-beige"></span>
                                  <span>Beige</span>
                              </div>
                              <form class="">
                                  <select class="tf-select" name="id">
                                      <option value="46633906045232" selected="">S - $8.00</option>
                                      <option value="47256262738224">M - $8.00</option>
                                      <option value="47256262770992">L - $8.00</option>
                                      <option value="47256262803760">XL - $8.00</option>
                                  </select>
                                  <a href="javascript:void(0);"
                                      class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn btn-add-to-cart"><span>Add
                                          to cart</span></a>
                              </form>
                          </div>
                      </div>

                      <input type="checkbox" class="sr-only" id="remove-compare-color-beige-2">
                      <div class="tf-compare-color-item">
                          <div class="tf-compare-color-top">
                              <label for="remove-compare-color-beige-2" class="tf-compare-color-remove">Remove</label>
                              <img class="lazyload" data-src="assets/images/shop/products/hmgoepprod12.jpg"
                                  src="assets/images/shop/products/hmgoepprod12.jpg" alt="">
                          </div>
                          <div class="tf-compare-color-bottom">
                              <div class="tf-compare-color-color">
                                  <span class="tf-color-list-color bg-color-blue"></span>
                                  <span>Blue</span>
                              </div>
                              <form class="">
                                  <select class="tf-select" name="id">
                                      <option value="46633906045232" selected="">S - $8.00</option>
                                      <option value="47256262738224">M - $8.00</option>
                                      <option value="47256262770992">L - $8.00</option>
                                      <option value="47256262803760">XL - $8.00</option>
                                  </select>
                                  <a href="javascript:void(0);"
                                      class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn btn-add-to-cart"><span>Add
                                          to cart</span></a>
                              </form>
                          </div>
                      </div>

                      <input type="checkbox" class="sr-only" id="remove-compare-color-beige-3">
                      <div class="tf-compare-color-item">
                          <div class="tf-compare-color-top">
                              <label for="remove-compare-color-beige-3" class="tf-compare-color-remove">Remove</label>
                              <img class="lazyload" data-src="assets/images/shop/products/hmgoepprod7.jpg"
                                  src="assets/images/shop/products/hmgoepprod7.jpg" alt="">
                          </div>
                          <div class="tf-compare-color-bottom">
                              <div class="tf-compare-color-color">
                                  <span class="tf-color-list-color bg-color-black"></span>
                                  <span>Black</span>
                              </div>
                              <form class="">
                                  <select class="tf-select" name="id">
                                      <option value="46633906045232" selected="">S - $8.00</option>
                                      <option value="47256262738224">M - $8.00</option>
                                      <option value="47256262770992">L - $8.00</option>
                                      <option value="47256262803760">XL - $8.00</option>
                                  </select>
                                  <a href="javascript:void(0);"
                                      class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn btn-add-to-cart"><span>Add
                                          to cart</span></a>
                              </form>
                          </div>
                      </div>

                      <input type="checkbox" class="sr-only" id="remove-compare-color-beige-4">
                      <div class="tf-compare-color-item">
                          <div class="tf-compare-color-top">
                              <label for="remove-compare-color-beige-4" class="tf-compare-color-remove">Remove</label>
                              <img class="lazyload" data-src="assets/images/shop/products/hmgoepprod14.jpg"
                                  src="assets/images/shop/products/hmgoepprod14.jpg" alt="">
                          </div>
                          <div class="tf-compare-color-bottom">
                              <div class="tf-compare-color-color">
                                  <span class="tf-color-list-color bg-color-white"></span>
                                  <span>White</span>
                              </div>
                              <form class="">
                                  <select class="tf-select" name="id">
                                      <option value="46633906045232" selected="">S - $8.00</option>
                                      <option value="47256262738224">M - $8.00</option>
                                      <option value="47256262770992">L - $8.00</option>
                                      <option value="47256262803760">XL - $8.00</option>
                                  </select>
                                  <a href="javascript:void(0);"
                                      class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn btn-add-to-cart"><span>Add
                                          to cart</span></a>
                              </form>
                          </div>
                      </div>

                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal compare_color -->

  <!-- modal ask_question -->
  <div class="modal modalCentered fade modalDemo tf-product-modal modal-part-content" id="ask_question">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Ask a question</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="overflow-y-auto">
                  <form class="">
                      <fieldset class="">
                          <label for="">Name *</label>
                          <input type="text" placeholder="" class="" name="text" tabindex="2" value=""
                              aria-required="true" required="">
                      </fieldset>
                      <fieldset class="">
                          <label for="">Email *</label>
                          <input type="email" placeholder="" class="" name="text" tabindex="2" value=""
                              aria-required="true" required="">
                      </fieldset>
                      <fieldset class="">
                          <label for="">Phone number</label>
                          <input type="number" placeholder="" class="" name="text" tabindex="2" value=""
                              aria-required="true" required="">
                      </fieldset>
                      <fieldset class="">
                          <label for="">Message</label>
                          <textarea name="message" rows="4" placeholder="" class="" tabindex="2" aria-required="true"
                              required=""></textarea>
                      </fieldset>
                      <button type="submit"
                          class="tf-btn w-100 btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn"><span>Send</span></button>
                  </form>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal ask_question -->

  <!-- modal delivery_return -->
  <div class="modal modalCentered fade modalDemo tf-product-modal modal-part-content" id="delivery_return">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Shipping & Delivery</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="overflow-y-auto">
                  <div class="tf-product-popup-delivery">
                      <div class="title">Delivery</div>
                      <p class="text-paragraph">All orders shipped with UPS Express.</p>
                      <p class="text-paragraph">Always free shipping for orders over US $250.</p>
                      <p class="text-paragraph">All orders are shipped with a UPS tracking number.</p>
                  </div>
                  <div class="tf-product-popup-delivery">
                      <div class="title">Returns</div>
                      <p class="text-paragraph">Items returned within 14 days of their original shipment date in same
                          as new condition will be eligible for a full refund or store credit.</p>
                      <p class="text-paragraph">Refunds will be charged back to the original form of payment used for
                          purchase.</p>
                      <p class="text-paragraph">Customer is responsible for shipping charges when making returns and
                          shipping/handling fees of original purchase is non-refundable.</p>
                      <p class="text-paragraph">All sale items are final purchases.</p>
                  </div>
                  <div class="tf-product-popup-delivery">
                      <div class="title">Help</div>
                      <p class="text-paragraph">Give us a shout if you have any other questions and/or concerns.</p>
                      <p class="text-paragraph">Email: <a href="mailto:contact@domain.com"
                              aria-describedby="a11y-external-message"><span
                                  class="__cf_email__">contact@domain.com</span></a></p>
                      <p class="text-paragraph mb-0">Phone: +1 (23) 456 789</p>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal delivery_return -->
  <!-- modal share social -->
  <div class="modal modalCentered fade modalDemo tf-product-modal modal-part-content" id="share_social">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Share</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="overflow-y-auto">
                  <ul class="tf-social-icon d-flex gap-10">
                      <li><a href="#" class="box-icon social-facebook bg_line"><i class="icon icon-fb"></i></a></li>
                      <li><a href="#" class="box-icon social-twiter bg_line"><i class="icon icon-Icon-x"></i></a></li>
                      <li><a href="#" class="box-icon social-instagram bg_line"><i
                                  class="icon icon-instagram"></i></a></li>
                      <li><a href="#" class="box-icon social-tiktok bg_line"><i class="icon icon-tiktok"></i></a></li>
                      <li><a href="#" class="box-icon social-pinterest bg_line"><i
                                  class="icon icon-pinterest-1"></i></a></li>
                  </ul>
                  <form class="form-share" method="post" accept-charset="utf-8">
                      <fieldset>
                          <input type="text" value="https://themesflat.co/html/ecomus/" tabindex="0"
                              aria-required="true">
                      </fieldset>
                      <div class="button-submit">
                          <button class="tf-btn btn-sm radius-3 btn-fill btn-icon animate-hover-btn"
                              type="button">Copy</button>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal share social -->
  <!-- gotop -->
  <button id="goTop">
      <span class="border-progress"></span>
      <span class="icon icon-arrow-up"></span>
  </button>
  <!-- /gotop -->

  <!-- toolbar-bottom -->
 <div class="tf-toolbar-bottom type-1150">
      <div class="toolbar-item">
          <a href="#toolbarShopmb" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
              <div class="toolbar-icon">
                  <i class="icon-shop"></i>
              </div>
              <div class="toolbar-label">Shop</div>
          </a>
      </div>

      <div class="toolbar-item">
          <a href="#canvasSearch" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
              <div class="toolbar-icon">
                  <i class="icon-search"></i>
              </div>
              <div class="toolbar-label">Recherche</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a  (click)="goToAccount($event)" data-bs-toggle="modal">
              <div class="toolbar-icon">
                  <i class="icon-account"></i>
              </div>
              <div class="toolbar-label">Compte</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a href="/wishlist">
              <div class="toolbar-icon">
                  <i class="icon-heart"></i>
                  <div class="toolbar-count">{{ wishlistCount }}</div>
              </div>
              <div class="toolbar-label">Favoris</div>
          </a>
      </div>
      <div class="toolbar-item">
          <a href="#shoppingCart" data-bs-toggle="modal">
              <div class="toolbar-icon">
                  <i class="icon-bag"></i>
                  <div class="toolbar-count">{{ cartCount }}</div>
              </div>
              <div class="toolbar-label">Panier</div>
          </a>
      </div>
  </div>
  <!-- /toolbar-bottom -->
  <!-- modalDemo -->
  <div class="modal fade modalDemo" id="modalDemo">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <h5 class="demo-title">Ultimate HTML Theme</h5>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="mega-menu">
                  <div class="row-demo">
                      <div class="demo-item">
                          <a href="index.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-01.jpg"
                                      src="assets/images/demo/home-01.jpg" alt="home-01">
                                  <div class="demo-label">
                                      <span class="demo-new">New</span>
                                      <span>Trend</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Fashion 01</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-multi-brand.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-multi-brand.jpg"
                                      src="assets/images/demo/home-multi-brand.jpg" alt="home-multi-brand">
                                  <div class="demo-label">
                                      <span class="demo-new">New</span>
                                      <span class="demo-hot">Hot</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Multi Brand</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-02.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-02.jpg"
                                      src="assets/images/demo/home-02.jpg" alt="home-02">
                                  <div class="demo-label">
                                      <span class="demo-hot">Hot</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Fashion 02</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-03.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-03.jpg"
                                      src="assets/images/demo/home-03.jpg" alt="home-03">
                              </div>
                              <span class="demo-name">Home Fashion 03</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-04.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-04.jpg"
                                      src="assets/images/demo/home-04.jpg" alt="home-04">
                              </div>
                              <span class="demo-name">Home Fashion 04</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-05.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-05.jpg"
                                      src="assets/images/demo/home-05.jpg" alt="home-05">
                              </div>
                              <span class="demo-name">Home Fashion 05</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-06.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-06.jpg"
                                      src="assets/images/demo/home-06.jpg" alt="home-06">
                              </div>
                              <span class="demo-name">Home Fashion 06</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-drinkwear.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-drinkwear.png"
                                      src="assets/images/demo/home-drinkwear.png" alt="home-drinkwear">
                                  <div class="demo-label">
                                      <span class="demo-new">New</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Drinkwear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-supplement.html">
                              <div class="demo-image position-relative">
                                  <img class="lazyload" data-src="assets/images/demo/home-supplement.png"
                                      src="assets/images/demo/home-supplement.png" alt="home-supplement">
                                  <div class="demo-label">
                                      <span class="demo-new">New</span>
                                  </div>
                              </div>
                              <span class="demo-name">Home Supplement</span>
                          </a>
                      </div>

                      <div class="demo-item">
                          <a href="home-personalized-pod.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-personalized-pod.jpg"
                                      src="assets/images/demo/home-personalized-pod.jpg" alt="home-personalized-pod">
                              </div>
                              <span class="demo-name">Home Personalized Pod</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-pickleball.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-pickleball.png"
                                      src="assets/images/demo/home-pickleball.png" alt="home-pickleball">
                              </div>
                              <span class="demo-name">Home Pickleball</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-ceramic.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-ceramic.png"
                                      src="assets/images/demo/home-ceramic.png" alt="home-ceramic">
                              </div>
                              <span class="demo-name">Home Ceramic</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-food.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-food.png"
                                      src="assets/images/demo/home-food.png" alt="home-food">
                              </div>
                              <span class="demo-name">Home Food</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-camp-and-hike.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-camp-and-hike.png"
                                      src="assets/images/demo/home-camp-and-hike.png" alt="home-camp-and-hike">
                              </div>
                              <span class="demo-name">Home Camp And Hike</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-07.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-07.jpg"
                                      src="assets/images/demo/home-07.jpg" alt="home-07">
                              </div>
                              <span class="demo-name">Home Fashion 07</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-08.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-08.jpg"
                                      src="assets/images/demo/home-08.jpg" alt="home-08">
                              </div>
                              <span class="demo-name">Home Fashion 08</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-skincare.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-skincare.jpg"
                                      src="assets/images/demo/home-skincare.jpg" alt="home-skincare">
                              </div>
                              <span class="demo-name">Home Skincare</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-headphone.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-headphone.jpg"
                                      src="assets/images/demo/home-headphone.jpg" alt="home-headphone">
                              </div>
                              <span class="demo-name">Home Headphone</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-giftcard.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-giftcard.jpg"
                                      src="assets/images/demo/home-giftcard.jpg" alt="home-gift-card">
                              </div>
                              <span class="demo-name">Home Gift Card</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-furniture.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-furniture.jpg"
                                      src="assets/images/demo/home-furniture.jpg" alt="home-furniture">
                              </div>
                              <span class="demo-name">Home Furniture</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-furniture-02.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-furniture2.jpg"
                                      src="assets/images/demo/home-furniture2.jpg" alt="home-furniture-2">
                              </div>
                              <span class="demo-name">Home Furniture 2</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-skateboard.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-skateboard.jpg"
                                      src="assets/images/demo/home-skateboard.jpg" alt="home-skateboard">
                              </div>
                              <span class="demo-name">Home Skateboard</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-stroller.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-stroller.jpg"
                                      src="assets/images/demo/home-stroller.jpg" alt="home-stroller">
                              </div>
                              <span class="demo-name">Home Stroller</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-decor.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-decor.jpg"
                                      src="assets/images/demo/home-decor.jpg" alt="home-decor">
                              </div>
                              <span class="demo-name">Home Decor</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-electronic.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-electronic.jpg"
                                      src="assets/images/demo/home-electronic.jpg" alt="home-electronic">
                              </div>
                              <span class="demo-name">Home Electronic</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-setup-gear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-setup-gear.jpg"
                                      src="assets/images/demo/home-setup-gear.jpg" alt="home-setup-gear">
                              </div>
                              <span class="demo-name">Home Setup Gear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-dog-accessories.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-dog-accessories.jpg"
                                      src="assets/images/demo/home-dog-accessories.jpg" alt="home-dog-accessories">
                              </div>
                              <span class="demo-name">Home Dog Accessories</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-kitchen-wear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-kitchen.jpg"
                                      src="assets/images/demo/home-kitchen.jpg" alt="home-kitchen-wear">
                              </div>
                              <span class="demo-name">Home Kitchen Wear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-phonecase.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-phonecase.jpg"
                                      src="assets/images/demo/home-phonecase.jpg" alt="home-phonecase">
                              </div>
                              <span class="demo-name">Home Phonecase</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-paddle-boards.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home_paddle_board.jpg"
                                      src="assets/images/demo/home_paddle_board.jpg" alt="home-paddle_board">
                              </div>
                              <span class="demo-name">Home Paddle Boards</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-glasses.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-glasses.jpg"
                                      src="assets/images/demo/home-glasses.jpg" alt="home-glasses">
                              </div>
                              <span class="demo-name">Home Glasses</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-pod-store.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-pod-store.jpg"
                                      src="assets/images/demo/home-pod-store.jpg" alt="home-pod-store">
                              </div>
                              <span class="demo-name">Home POD Store</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-activewear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-activewear.jpg"
                                      src="assets/images/demo/home-activewear.jpg" alt="home-activewear">
                              </div>
                              <span class="demo-name">Activewear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-handbag.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-handbag.jpg"
                                      src="assets/images/demo/home-handbag.jpg" alt="home-handbag">
                              </div>
                              <span class="demo-name">Home Handbag</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-tee.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-tee.jpg"
                                      src="assets/images/demo/home-tee.jpg" alt="home-tee">
                              </div>
                              <span class="demo-name">Home Tee</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-sock.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-socks.jpg"
                                      src="assets/images/demo/home-socks.jpg" alt="home-sock">
                              </div>
                              <span class="demo-name">Home Sock</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-jewerly.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-jewelry.jpg"
                                      src="assets/images/demo/home-jewelry.jpg" alt="home-jewelry">
                              </div>
                              <span class="demo-name">Home Jewelry</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-sneaker.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-sneaker.jpg"
                                      src="assets/images/demo/home-sneaker.jpg" alt="home-sneaker">
                              </div>
                              <span class="demo-name">Home Sneaker</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-accessories.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-accessories.jpg"
                                      src="assets/images/demo/home-accessories.jpg" alt="home-accessories">
                              </div>
                              <span class="demo-name">Home Accessories</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-grocery.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-gocery.jpg"
                                      src="assets/images/demo/home-gocery.jpg" alt="home-grocery">
                              </div>
                              <span class="demo-name">Home Grocery</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-baby.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-baby.jpg"
                                      src="assets/images/demo/home-baby.jpg" alt="home-baby">
                              </div>
                              <span class="demo-name">Home Baby</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-cosmetic.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-cosmetic.png"
                                      src="assets/images/demo/home-cosmetic.png" alt="home-cosmetic">
                              </div>
                              <span class="demo-name">Home Cosmetic</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-plant.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-plant.png"
                                      src="assets/images/demo/home-plant.png" alt="home-plant">
                              </div>
                              <span class="demo-name">Home Plant</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-swimwear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-swimwear.png"
                                      src="assets/images/demo/home-swimwear.png" alt="home-swimwear">
                              </div>
                              <span class="demo-name">Home Swimwear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-electric-bike.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-electric-bike.png"
                                      src="assets/images/demo/home-electric-bike.png" alt="home-electric-bike">
                              </div>
                              <span class="demo-name">Home Electric Bike</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-footwear.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-footwear.jpg"
                                      src="assets/images/demo/home-footwear.jpg" alt="home-footwear">
                              </div>
                              <span class="demo-name">Home Footwear</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-book-store.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-bookstore.png"
                                      src="assets/images/demo/home-bookstore.png" alt="home-bookstore">
                              </div>
                              <span class="demo-name">Home Bookstore</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-gaming-accessories.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-gaming-accessories.png"
                                      src="assets/images/demo/home-gaming-accessories.png" alt="home-gaming-accessories">
                              </div>
                              <span class="demo-name">Home Gaming Accessories</span>
                          </a>
                      </div>
                      <div class="demo-item">
                          <a href="home-parallax.html">
                              <div class="demo-image">
                                  <img class="lazyload" data-src="assets/images/demo/home-skincare.jpg"
                                      src="assets/images/demo/home-skincare.jpg" alt="home-skincare">
                              </div>
                              <span class="demo-name">Home Parallax</span>
                          </a>
                      </div>
                  </div>
              </div>

          </div>
      </div>
  </div>
  <!-- /modalDemo -->

  <!-- mobile menu -->
  <div class="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
      <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
      <div class="mb-canvas-content">
          <div class="mb-body">
              <ul class="nav-ul-mb" id="wrapper-menu-navigation">
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-one" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-one">
                          <span>Home</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-one" class="collapse">
                          <ul class="sub-nav-menu">
                              <li><a href="index.html" class="sub-nav-link">Home Fashion 01</a></li>
                              <li><a href="home-02.html" class="sub-nav-link">Home Fashion 02</a></li>
                              <li><a href="home-03.html" class="sub-nav-link">Home Fashion 03</a></li>
                              <li><a href="home-04.html" class="sub-nav-link">Home Fashion 04</a></li>
                              <li><a href="home-05.html" class="sub-nav-link">Home Fashion 05</a></li>
                              <li><a href="home-06.html" class="sub-nav-link">Home Fashion 06</a></li>
                              <li><a href="home-07.html" class="sub-nav-link">Home Fashion 07</a></li>
                              <li><a href="home-08.html" class="sub-nav-link">Home Fashion 08</a></li>
                              <li><a href="home-giftcard.html" class="sub-nav-link">Home Gift Card</a></li>
                              <li><a href="home-headphone.html" class="sub-nav-link">Home Headphone</a></li>
                              <li><a href="home-multi-brand.html" class="sub-nav-link">Home Multi Brand</a></li>
                              <li><a href="home-skincare.html" class="sub-nav-link">Home skincare</a></li>
                              <li><a href="home-furniture.html" class="sub-nav-link">Home Furniture</a></li>
                              <li><a href="home-furniture-02.html" class="sub-nav-link">Home Furniture 2</a></li>
                              <li><a href="home-skateboard.html" class="sub-nav-link">Home Skateboard</a></li>
                              <li><a href="home-stroller.html" class="sub-nav-link">Home Stroller</a></li>
                              <li><a href="home-decor.html" class="sub-nav-link">Home Decor</a></li>
                              <li><a href="home-electronic.html" class="sub-nav-link">Home Electronic</a></li>
                              <li><a href="home-setup-gear.html" class="sub-nav-link">Home Setup Gear</a></li>
                              <li><a href="home-dog-accessories.html" class="sub-nav-link">Home Dog Accessories</a>
                              </li>
                              <li><a href="home-kitchen-wear.html" class="sub-nav-link">Home Kitchen Wear</a></li>
                              <li><a href="home-phonecase.html" class="sub-nav-link">Home Phonecase</a></li>
                              <li><a href="home-paddle-boards.html" class="sub-nav-link">Home Paddle Boards</a></li>
                              <li><a href="home-glasses.html" class="sub-nav-link">Home Glasses</a></li>
                              <li><a href="home-pod-store.html" class="sub-nav-link">Home POD Store</a></li>
                              <li><a href="home-activewear.html" class="sub-nav-link">Home Activewear</a></li>
                              <li><a href="home-handbag.html" class="sub-nav-link">Home Handbag</a></li>
                              <li><a href="home-tee.html" class="sub-nav-link">Home Tee</a></li>
                              <li><a href="home-sock.html" class="sub-nav-link">Home Sock</a></li>
                              <li><a href="home-jewerly.html" class="sub-nav-link">Home Jewelry</a></li>
                              <li><a href="home-sneaker.html" class="sub-nav-link">Home Sneaker</a></li>
                              <li><a href="home-accessories.html" class="sub-nav-link">Home Accessories</a></li>
                              <li><a href="home-grocery.html" class="sub-nav-link">Home Grocery</a></li>
                              <li><a href="home-baby.html" class="sub-nav-link">Home Baby</a></li>
                              <li><a href="home-personalized-pod.html" class="sub-nav-link">Home Personalized Pod</a>
                              </li>
                              <li><a href="home-pickleball.html" class="sub-nav-link">Home Pickleball</a></li>
                              <li><a href="home-ceramic.html" class="sub-nav-link">Home Ceramic</a></li>
                              <li><a href="home-food.html" class="sub-nav-link">Home Food</a></li>
                              <li><a href="home-camp-and-hike.html" class="sub-nav-link">Home Camp And Hike</a></li>
                              <li><a href="home-cosmetic.html" class="sub-nav-link">Home Cosmetic</a></li>
                              <li><a href="home-plant.html" class="sub-nav-link">Home Plant</a></li>
                              <li><a href="home-swimwear.html" class="sub-nav-link">Home Swimwear</a></li>
                              <li><a href="home-electric-bike.html" class="sub-nav-link">Home Electric Bike</a></li>
                              <li><a href="home-footwear.html" class="sub-nav-link">Home Footwear</a></li>
                              <li><a href="home-book-store.html" class="sub-nav-link">Home Book Store</a></li>
                              <li><a href="home-gaming-accessories.html" class="sub-nav-link">Home Gaming
                                      Accessories</a></li>
                              <li><a href="home-drinkwear.html" class="sub-nav-link">Home Drinkwear</a></li>
                              <li><a href="home-supplement.html" class="sub-nav-link">Home Supplement</a></li>
                              <li><a href="home-parallax.html" class="sub-nav-link">Home Parallax</a></li>
                          </ul>
                      </div>

                  </li>
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-two" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-two">
                          <span>Shop</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-two" class="collapse">
                          <ul class="sub-nav-menu" id="sub-menu-navigation">
                              <li><a href="#sub-shop-one" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-shop-one">
                                      <span>Shop layouts</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-shop-one" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="shop-default.html" class="sub-nav-link">Default</a></li>
                                          <li><a href="shop-left-sidebar.html" class="sub-nav-link">Left sidebar</a>
                                          </li>
                                          <li><a href="shop-right-sidebar.html" class="sub-nav-link">Right sidebar</a>
                                          </li>
                                          <li><a href="shop-fullwidth.html" class="sub-nav-link">Fullwidth</a></li>
                                          <li><a href="shop-collection-sub.html" class="sub-nav-link">Sub
                                                  collection</a></li>
                                          <li><a href="shop-collection-list.html" class="sub-nav-link">Collections
                                                  list</a></li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-shop-two" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-shop-two">
                                      <span>Features</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-shop-two" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="shop-link.html" class="sub-nav-link">Pagination links</a></li>
                                          <li><a href="shop-loadmore.html" class="sub-nav-link">Pagination
                                                  loadmore</a></li>
                                          <li><a href="shop-infinite-scrolling.html" class="sub-nav-link">Pagination
                                                  infinite scrolling</a></li>
                                          <li><a href="shop-filter-sidebar.html" class="sub-nav-link">Filter
                                                  sidebar</a></li>
                                          <li><a href="shop-filter-hidden.html" class="sub-nav-link">Filter hidden</a>
                                          </li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-shop-three" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-shop-three">
                                      <span>Product styles</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-shop-three" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">

                                          <li><a href="product-style-01.html" class="sub-nav-link">Product style
                                                  01</a></li>
                                          <li><a href="product-style-02.html" class="sub-nav-link">Product style
                                                  02</a></li>
                                          <li><a href="product-style-03.html" class="sub-nav-link">Product style
                                                  03</a></li>
                                          <li><a href="product-style-04.html" class="sub-nav-link">Product style
                                                  04</a></li>
                                          <li><a href="product-style-05.html" class="sub-nav-link">Product style
                                                  05</a></li>
                                          <li><a href="product-style-06.html" class="sub-nav-link">Product style
                                                  06</a></li>
                                          <li><a href="product-style-07.html" class="sub-nav-link">Product style
                                                  07</a></li>
                                      </ul>
                                  </div>
                              </li>
                          </ul>
                      </div>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-three" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-three">
                          <span>Products</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-three" class="collapse">
                          <ul class="sub-nav-menu" id="sub-menu-navigation1">
                              <li>
                                  <a href="#sub-product-one" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-product-one">
                                      <span>Product layouts</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-product-one" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="product-detail.html" class="sub-nav-link">Product default</a>
                                          </li>
                                          <li><a href="product-grid-1.html" class="sub-nav-link">Product grid 1</a>
                                          </li>
                                          <li><a href="product-grid-2.html" class="sub-nav-link">Product grid 2</a>
                                          </li>
                                          <li><a href="product-stacked.html" class="sub-nav-link">Product stacked</a>
                                          </li>
                                          <li><a href="product-right-thumbnails.html" class="sub-nav-link">Product
                                                  right thumbnails</a></li>
                                          <li><a href="product-bottom-thumbnails.html" class="sub-nav-link">Product
                                                  bottom thumbnails</a></li>
                                          <li><a href="product-drawer-sidebar.html" class="sub-nav-link">Product
                                                  drawer sidebar</a></li>
                                          <li><a href="product-description-accordion.html"
                                                  class="sub-nav-link">Product description accordion</a></li>
                                          <li><a href="product-description-list.html" class="sub-nav-link">Product
                                                  description list</a></li>
                                          <li><a href="product-description-vertical.html" class="sub-nav-link">Product
                                                  description vertical</a></li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-product-two" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-product-two">
                                      <span>Product details</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-product-two" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="product-inner-zoom.html" class="sub-nav-link">Product inner
                                                  zoom</a></li>
                                          <li><a href="product-zoom-magnifier.html" class="sub-nav-link">Product zoom
                                                  magnifier</a></li>
                                          <li><a href="product-no-zoom.html" class="sub-nav-link">Product no zoom</a>
                                          </li>
                                          <li><a href="product-photoswipe-popup.html" class="sub-nav-link">Product
                                                  photoswipe popup</a></li>
                                          <li><a href="product-zoom-popup.html" class="sub-nav-link">Product external
                                                  zoom and photoswipe popup</a></li>
                                          <li><a href="product-video.html" class="sub-nav-link">Product video</a></li>
                                          <li><a href="product-3d.html" class="sub-nav-link">Product 3D, AR models</a>
                                          </li>
                                          <li><a href="product-options-customizer.html" class="sub-nav-link">Product
                                                  options & customizer</a></li>
                                          <li><a href="product-advanced-types.html" class="sub-nav-link">Advanced
                                                  product types</a></li>
                                          <li><a href="product-giftcard.html" class="sub-nav-link">Recipient
                                                  information form for gift card products</a></li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-product-three" class="sub-nav-link collapsed"
                                      data-bs-toggle="collapse" aria-expanded="true"
                                      aria-controls="sub-product-three">
                                      <span>Product swatchs</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-product-three" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="product-color-swatch.html" class="sub-nav-link">Product color
                                                  swatch</a></li>
                                          <li><a href="product-rectangle.html" class="sub-nav-link">Product
                                                  rectangle</a></li>
                                          <li><a href="product-rectangle-color.html" class="sub-nav-link">Product
                                                  rectangle color</a></li>
                                          <li><a href="product-swatch-image.html" class="sub-nav-link">Product swatch
                                                  image</a></li>
                                          <li><a href="product-swatch-image-rounded.html" class="sub-nav-link">Product
                                                  swatch image rounded</a></li>
                                          <li><a href="product-swatch-dropdown.html" class="sub-nav-link">Product
                                                  swatch dropdown</a></li>
                                          <li><a href="product-swatch-dropdown-color.html"
                                                  class="sub-nav-link">Product swatch dropdown color</a></li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#sub-product-four" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-product-four">
                                      <span>Product features</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-product-four" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="product-frequently-bought-together.html"
                                                  class="sub-nav-link">Frequently bought together</a></li>
                                          <li><a href="product-frequently-bought-together-2.html"
                                                  class="sub-nav-link">Frequently bought together 2</a></li>
                                          <li><a href="product-upsell-features.html" class="sub-nav-link">Product
                                                  upsell features</a></li>
                                          <li><a href="product-pre-orders.html" class="sub-nav-link">Product
                                                  pre-orders</a></li>
                                          <li><a href="product-notification.html" class="sub-nav-link">Back in stock
                                                  notification</a></li>
                                          <li><a href="product-pickup.html" class="sub-nav-link">Product pickup</a>
                                          </li>
                                          <li><a href="product-images-grouped.html" class="sub-nav-link">Variant
                                                  images grouped</a></li>
                                          <li><a href="product-complimentary.html" class="sub-nav-link">Complimentary
                                                  products</a></li>
                                          <li><a href="product-quick-order-list.html"
                                                  class="sub-nav-link line-clamp">Quick order list<div
                                                      class="demo-label"><span class="demo-new">New</span></div></a>
                                          </li>
                                          <li><a href="product-detail-volume-discount.html"
                                                  class="sub-nav-link line-clamp">Volume Discount<div
                                                      class="demo-label"><span class="demo-new">New</span></div></a>
                                          </li>
                                          <li><a href="product-detail-volume-discount-grid.html"
                                                  class="sub-nav-link line-clamp">Volume Discount Grid<div
                                                      class="demo-label"><span class="demo-new">New</span></div></a>
                                          </li>
                                          <li><a href="product-detail-buyx-gety.html"
                                                  class="sub-nav-link line-clamp">Buy X Get Y<div class="demo-label">
                                                      <span class="demo-new">New</span>
                                                  </div></a></li>
                                      </ul>
                                  </div>
                              </li>
                          </ul>
                      </div>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-four" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-four">
                          <span>Pages</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-four" class="collapse">
                          <ul class="sub-nav-menu" id="sub-menu-navigation2">
                              <li><a href="about-us.html" class="sub-nav-link">About us</a></li>
                              <li><a href="brands.html" class="sub-nav-link line-clamp">Brands<div class="demo-label">
                                          <span class="demo-new">New</span>
                                      </div></a></li>
                              <li><a href="brands-v2.html" class="sub-nav-link">Brands V2</a></li>
                              <li><a href="contact-1.html" class="sub-nav-link">Contact 1</a></li>
                              <li><a href="contact-2.html" class="sub-nav-link">Contact 2</a></li>
                              <li><a href="faq-1.html" class="sub-nav-link">FAQ 01</a></li>
                              <li><a href="faq-2.html" class="sub-nav-link">FAQ 02</a></li>
                              <li><a href="our-store.html" class="sub-nav-link">Our store</a></li>
                              <li><a href="store-locations.html" class="sub-nav-link">Store locator</a></li>
                              <li><a href="timeline.html" class="sub-nav-link line-clamp">Timeline<div
                                          class="demo-label"><span class="demo-new">New</span></div></a></li>
                              <li><a href="view-cart.html" class="sub-nav-link line-clamp">View cart</a></li>
                              <li><a href="checkout.html" class="sub-nav-link line-clamp">Check out</a></li>
                              <li><a href="payment-confirmation.html" class="sub-nav-link line-clamp">Payment
                                      Confirmation</a></li>
                              <li><a href="payment-failure.html" class="sub-nav-link line-clamp">Payment Failure</a>
                              </li>
                              <li><a href="#sub-account" class="sub-nav-link collapsed" data-bs-toggle="collapse"
                                      aria-expanded="true" aria-controls="sub-account">
                                      <span>My Account</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="sub-account" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li><a href="my-account.html" class="sub-nav-link">My account</a></li>
                                          <li><a href="my-account-orders.html" class="sub-nav-link">My order</a></li>
                                          <li><a href="my-account-orders-details.html" class="sub-nav-link">My order
                                                  details</a></li>
                                          <li><a href="my-account-address.html" class="sub-nav-link">My address</a>
                                          </li>
                                          <li><a href="my-account-edit.html" class="sub-nav-link">My account
                                                  details</a></li>
                                          <li><a href="my-account-wishlist.html" class="sub-nav-link">My wishlist</a>
                                          </li>
                                      </ul>
                                  </div>
                              </li>
                              <li><a href="invoice.html" class="sub-nav-link line-clamp">Invoice</a></li>
                              <li><a href="404.html" class="sub-nav-link line-clamp">404</a></li>
                          </ul>
                      </div>

                  </li>
                  <li class="nav-mb-item">
                      <a href="#dropdown-menu-five" class="collapsed mb-menu-link current" data-bs-toggle="collapse"
                          aria-expanded="true" aria-controls="dropdown-menu-five">
                          <span>Blog</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="dropdown-menu-five" class="collapse">
                          <ul class="sub-nav-menu">
                              <li><a href="blog-grid.html" class="sub-nav-link">Grid layout</a></li>
                              <li><a href="blog-sidebar-left.html" class="sub-nav-link">Left sidebar</a></li>
                              <li><a href="blog-sidebar-right.html" class="sub-nav-link">Right sidebar</a></li>
                              <li><a href="blog-list.html" class="sub-nav-link">Blog list</a></li>
                              <li><a href="blog-detail.html" class="sub-nav-link">Single Post</a></li>
                          </ul>
                      </div>

                  </li>
                  <li class="nav-mb-item">
                      <a href="https://themeforest.net/item/ecomus-ultimate-html5-template/53417990?s_rank=3"
                          class="mb-menu-link">Buy now</a>
                  </li>
              </ul>
              <div class="mb-other-content">
                  <div class="d-flex group-icon">
                      <a href="wishlist.html" class="site-nav-icon"><i class="icon icon-heart"></i>Wishlist</a>
                      <a href="home-search.html" class="site-nav-icon"><i class="icon icon-search"></i>Search</a>
                  </div>
                  <div class="mb-notice">
                      <a href="contact-1.html" class="text-need">Need help ?</a>
                  </div>
                  <ul class="mb-info">
                      <li>Address: 1234 Fashion Street, Suite 567, <br> New York, NY 10001</li>
                      <li>Email: <b>info@fashionshop.com</b></li>
                      <li>Phone: <b>(212) 555-1234</b></li>
                  </ul>
              </div>
          </div>
          <div class="mb-bottom">
              <a href="login.html" class="site-nav-icon"><i class="icon icon-account"></i>Login</a>
              <div class="bottom-bar-language">
                  <div class="tf-currencies">
                      <select class="image-select center style-default type-currencies">
                          <option data-thumbnail="assets/images/country/fr.svg">EUR € | France</option>
                          <option data-thumbnail="assets/images/country/de.svg">EUR € | Germany</option>
                          <option selected data-thumbnail="assets/images/country/us.svg">USD $ | United States</option>
                          <option data-thumbnail="assets/images/country/vn.svg">VND ₫ | Vietnam</option>
                      </select>
                  </div>
                  <div class="tf-languages">
                      <select class="image-select center style-default type-languages">
                          <option>English</option>
                          <option>العربية</option>
                          <option>简体中文</option>
                          <option>اردو</option>
                      </select>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /mobile menu -->



  <!-- canvasSearch -->
  <div class="offcanvas offcanvas-end canvas-search" id="canvasSearch">
      <div class="canvas-wrapper">
          <header class="tf-search-head">
              <div class="title fw-5">
                  Search our site
                  <div class="close">
                      <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
                  </div>
              </div>
              <div class="tf-search-sticky">
                  <form class="tf-mini-search-frm">
                      <fieldset class="text">
                          <input type="text" placeholder="Search" class="" name="text" tabindex="0" value=""
                              aria-required="true" required="">
                      </fieldset>
                      <button class="" type="submit"><i class="icon-search"></i></button>
                  </form>
              </div>
          </header>
          <div class="canvas-body p-0">
              <div class="tf-search-content">
                  <div class="tf-cart-hide-has-results">
                      <div class="tf-col-quicklink">
                          <div class="tf-search-content-title fw-5">Quick link</div>
                          <ul class="tf-quicklink-list">
                              <li class="tf-quicklink-item">
                                  <a href="shop-default.html" class="">Fashion</a>
                              </li>
                              <li class="tf-quicklink-item">
                                  <a href="shop-default.html" class="">Men</a>
                              </li>
                              <li class="tf-quicklink-item">
                                  <a href="shop-default.html" class="">Women</a>
                              </li>
                              <li class="tf-quicklink-item">
                                  <a href="shop-default.html" class="">Accessories</a>
                              </li>
                          </ul>
                      </div>
                      <div class="tf-col-content">
                          <div class="tf-search-content-title fw-5">Need some inspiration?</div>
                          <div class="tf-search-hidden-inner">
                              <div class="tf-loop-item">
                                  <div class="image">
                                      <a href="product-detail.html">
                                          <img src="assets/assets/images/products/white-3.jpg" alt="">
                                      </a>
                                  </div>
                                  <div class="content">
                                      <a href="product-detail.html">Cotton jersey top</a>
                                      <div class="tf-product-info-price">
                                          <div class="compare-at-price">$10.00</div>
                                          <div class="price-on-sale fw-6">$8.00</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="tf-loop-item">
                                  <div class="image">
                                      <a href="product-detail.html">
                                          <img src="assets/assets/images/products/white-2.jpg" alt="">
                                      </a>
                                  </div>
                                  <div class="content">
                                      <a href="product-detail.html">Mini crossbody bag</a>
                                      <div class="tf-product-info-price">
                                          <div class="price fw-6">$18.00</div>
                                      </div>
                                  </div>
                              </div>
                              <div class="tf-loop-item">
                                  <div class="image">
                                      <a href="product-detail.html">
                                          <img src="assets/assets/images/products/white-1.jpg" alt="">
                                      </a>
                                  </div>
                                  <div class="content">
                                      <a href="product-detail.html">Oversized Printed T-shirt</a>
                                      <div class="tf-product-info-price">
                                          <div class="price fw-6">$18.00</div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /canvasSearch -->

  <!-- toolbarShopmb -->
  <div class="offcanvas offcanvas-start canvas-mb toolbar-shop-mobile" id="toolbarShopmb">
      <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
      <div class="mb-canvas-content">
          <div class="mb-body">
              <ul class="nav-ul-mb" id="wrapper-menu-navigation">
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate1.jpg" alt="">
                          </div>
                          <span>Accessories</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate2.jpg" alt="">
                          </div>
                          <span>Dog</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate3.jpg" alt="">
                          </div>
                          <span>Grocery</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate4.png" alt="">
                          </div>
                          <span>Handbag</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#cate-menu-one" class="tf-category-link has-children collapsed mb-menu-link"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-menu-one">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate5.jpg" alt="">
                          </div>
                          <span>Fashion</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="cate-menu-one" class="collapse list-cate">
                          <ul class="sub-nav-menu" id="cate-menu-navigation">
                              <li>
                                  <a href="#cate-shop-one"
                                      class="tf-category-link has-children sub-nav-link collapsed"
                                      data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-shop-one">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate6.jpg" alt="">
                                      </div>
                                      <span>Mens</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="cate-shop-one" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li>
                                              <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                                  <div class="image">
                                                      <img src="assets/images/shop/cate/cate1.jpg" alt="">
                                                  </div>
                                                  <span>Accessories</span>
                                              </a>
                                          </li>
                                          <li>
                                              <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                                  <div class="image">
                                                      <img src="assets/images/shop/cate/cate8.jpg" alt="">
                                                  </div>
                                                  <span>Shoes</span>
                                              </a>
                                          </li>
                                      </ul>
                                  </div>
                              </li>
                              <li>
                                  <a href="#cate-shop-two"
                                      class="tf-category-link has-children sub-nav-link collapsed"
                                      data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-shop-two">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate9.jpg" alt="">
                                      </div>
                                      <span>Womens</span>
                                      <span class="btn-open-sub"></span>
                                  </a>
                                  <div id="cate-shop-two" class="collapse">
                                      <ul class="sub-nav-menu sub-menu-level-2">
                                          <li>
                                              <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                                  <div class="image">
                                                      <img src="assets/images/shop/cate/cate4.png" alt="">
                                                  </div>
                                                  <span>Handbag</span>
                                              </a>
                                          </li>
                                          <li>
                                              <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                                  <div class="image">
                                                      <img src="assets/images/shop/cate/cate7.jpg" alt="">
                                                  </div>
                                                  <span>Tee</span>
                                              </a>
                                          </li>
                                      </ul>
                                  </div>
                              </li>
                          </ul>
                      </div>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#cate-menu-two" class="tf-category-link has-children collapsed mb-menu-link"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-menu-two">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate6.jpg" alt="">
                          </div>
                          <span>Men</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="cate-menu-two" class="collapse list-cate">
                          <ul class="sub-nav-menu" id="cate-menu-navigation1">
                              <li>
                                  <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate1.jpg" alt="">
                                      </div>
                                      <span>Accessories</span>
                                  </a>
                              </li>
                              <li>
                                  <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate8.jpg" alt="">
                                      </div>
                                      <span>Shoes</span>
                                  </a>
                              </li>
                          </ul>
                      </div>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate7.jpg" alt="">
                          </div>
                          <span>Tee</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="shop-default.html" class="tf-category-link mb-menu-link">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate8.jpg" alt="">
                          </div>
                          <span>Shoes</span>
                      </a>
                  </li>
                  <li class="nav-mb-item">
                      <a href="#cate-menu-three" class="tf-category-link has-children collapsed mb-menu-link"
                          data-bs-toggle="collapse" aria-expanded="true" aria-controls="cate-menu-three">
                          <div class="image">
                              <img src="assets/images/shop/cate/cate9.jpg" alt="">
                          </div>
                          <span>Women</span>
                          <span class="btn-open-sub"></span>
                      </a>
                      <div id="cate-menu-three" class="collapse list-cate">
                          <ul class="sub-nav-menu" id="cate-menu-navigation2">
                              <li>
                                  <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate4.png" alt="">
                                      </div>
                                      <span>Handbag</span>
                                  </a>
                              </li>
                              <li>
                                  <a href="shop-default.html" class="tf-category-link sub-nav-link">
                                      <div class="image">
                                          <img src="assets/images/shop/cate/cate7.jpg" alt="">
                                      </div>
                                      <span>Tee</span>
                                  </a>
                              </li>
                          </ul>
                      </div>
                  </li>
              </ul>
          </div>
          <div class="mb-bottom">
              <a href="shop-default.html" class="tf-btn fw-5 btn-line">View all collection<i
                      class="icon icon-arrow1-top-left"></i></a>
          </div>
      </div>
  </div>
  <!-- /toolbarShopmb -->

  <!-- modal login -->
  <div class="modal modalCentered fade form-sign-in modal-part-content" id="login">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Log in</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-login-form">
                  <form class="" action="my-account.html" accept-charset="utf-8">
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="email" name="">
                          <label class="tf-field-label" for="">Email *</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="password" name="">
                          <label class="tf-field-label" for="">Password *</label>
                      </div>
                      <div>
                          <a href="#forgotPassword" data-bs-toggle="modal" class="btn-link link">Forgot your
                              password?</a>
                      </div>
                      <div class="bottom">
                          <div class="w-100">
                              <button type="submit"
                                  class="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Log
                                      in</span></button>
                          </div>
                          <div class="w-100">
                              <a href="#register" data-bs-toggle="modal" class="btn-link fw-6 w-100 link">
                                  New customer? Create your account
                                  <i class="icon icon-arrow1-top-left"></i>
                              </a>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  <div class="modal modalCentered fade form-sign-in modal-part-content" id="forgotPassword">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Reset your password</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-login-form">
                  <form class="">
                      <div>
                          <p>Sign up for early Sale access plus tailored new arrivals, trends and promotions. To opt
                              out, click unsubscribe in our emails</p>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="email" name="">
                          <label class="tf-field-label" for="">Email *</label>
                      </div>
                      <div>
                          <a href="#login" data-bs-toggle="modal" class="btn-link link">Cancel</a>
                      </div>
                      <div class="bottom">
                          <div class="w-100">
                              <button type="submit"
                                  class="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Reset
                                      password</span></button>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  <div class="modal modalCentered fade form-sign-in modal-part-content" id="register">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Register</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-login-form">
                  <form class="">
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="text" name="">
                          <label class="tf-field-label" for="">First name</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="text" name="">
                          <label class="tf-field-label" for="">Last name</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="email" name="">
                          <label class="tf-field-label" for="">Email *</label>
                      </div>
                      <div class="tf-field style-1">
                          <input class="tf-field-input tf-input" placeholder=" " type="password" name="">
                          <label class="tf-field-label" for="">Password *</label>
                      </div>
                      <div class="bottom">
                          <div class="w-100">
                              <a href="register.html"
                                  class="tf-btn btn-fill animate-hover-btn radius-3 w-100 justify-content-center"><span>Register</span></a>
                          </div>
                          <div class="w-100">
                              <a href="#login" data-bs-toggle="modal" class="btn-link fw-6 w-100 link">
                                  Already have an account? Log in here
                                  <i class="icon icon-arrow1-top-left"></i>
                              </a>
                          </div>
                      </div>
                  </form>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal login -->



  <!-- modal compare -->
  <div class="offcanvas offcanvas-bottom canvas-compare" id="compare">
      <div class="canvas-wrapper">
          <header class="canvas-header">
              <div class="close-popup">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
              </div>
          </header>
          <div class="canvas-body">
              <div class="container">
                  <div class="row">
                      <div class="col-12">
                          <div class="tf-compare-list">
                              <div class="tf-compare-head">
                                  <div class="title">Compare Products</div>
                              </div>
                              <div class="tf-compare-offcanvas">
                                  <div class="tf-compare-item">
                                      <div class="position-relative">
                                          <div class="icon">
                                              <i class="icon-close"></i>
                                          </div>
                                          <a href="product-detail.html">
                                              <img class="radius-3" src="assets/images/products/orange-1.jpg" alt="">
                                          </a>
                                      </div>
                                  </div>
                                  <div class="tf-compare-item">
                                      <div class="position-relative">
                                          <div class="icon">
                                              <i class="icon-close"></i>
                                          </div>
                                          <a href="product-detail.html">
                                              <img class="radius-3" src="assets/images/products/pink-1.jpg" alt="">
                                          </a>
                                      </div>
                                  </div>
                              </div>
                              <div class="tf-compare-buttons">
                                  <div class="tf-compare-buttons-wrap">
                                      <a href="compare.html"
                                          class="tf-btn radius-3 btn-fill justify-content-center fw-6 fs-14 flex-grow-1 animate-hover-btn ">Compare</a>
                                      <div class="tf-compapre-button-clear-all link">
                                          Clear All
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal compare -->

  <!-- modal quick_add -->
  <div class="modal fade modalDemo" id="quick_add">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="wrap">
                  <div class="tf-product-info-item">
                      <div class="image">
                          <img src="assets/assets/images/products/orange-1.jpg" alt="">
                      </div>
                      <div class="content">
                          <a href="product-detail.html">Ribbed Tank Top</a>
                          <div class="tf-product-info-price">
                              <!-- <div class="price-on-sale">$8.00</div>
                              <div class="compare-at-price">$10.00</div>
                              <div class="badges-on-sale"><span>20</span>% OFF</div> -->
                              <div class="price">$18.00</div>
                          </div>
                      </div>
                  </div>
                  <div class="tf-product-info-variant-picker mb_15">
                      <div class="variant-picker-item">
                          <div class="variant-picker-label">
                              Color: <span class="fw-6 variant-picker-label-value">Orange</span>
                          </div>
                          <div class="variant-picker-values">
                              <input id="values-orange" type="radio" name="color" checked>
                              <label class="hover-tooltip radius-60" for="values-orange" data-value="Orange">
                                  <span class="btn-checkbox bg-color-orange"></span>
                                  <span class="tooltip">Orange</span>
                              </label>
                              <input id="values-black" type="radio" name="color">
                              <label class=" hover-tooltip radius-60" for="values-black" data-value="Black">
                                  <span class="btn-checkbox bg-color-black"></span>
                                  <span class="tooltip">Black</span>
                              </label>
                              <input id="values-white" type="radio" name="color">
                              <label class="hover-tooltip radius-60" for="values-white" data-value="White">
                                  <span class="btn-checkbox bg-color-white"></span>
                                  <span class="tooltip">White</span>
                              </label>
                          </div>
                      </div>
                      <div class="variant-picker-item">
                          <div class="variant-picker-label">
                              Size: <span class="fw-6 variant-picker-label-value">S</span>
                          </div>
                          <div class="variant-picker-values">
                              <input type="radio" name="size" id="values2-s" checked>
                              <label class="style-text" for="values2-s" data-value="S">
                                  <p>S</p>
                              </label>
                              <input type="radio" name="size" id="values2-m">
                              <label class="style-text" for="values2-m" data-value="M">
                                  <p>M</p>
                              </label>
                              <input type="radio" name="size" id="values2-l">
                              <label class="style-text" for="values2-l" data-value="L">
                                  <p>L</p>
                              </label>
                              <input type="radio" name="size" id="values2-xl">
                              <label class="style-text" for="values2-xl" data-value="XL">
                                  <p>XL</p>
                              </label>
                          </div>
                      </div>
                  </div>
                  <div class="tf-product-info-quantity mb_15">
                      <div class="quantity-title fw-6">Quantity</div>
                      <div class="wg-quantity">
                          <span class="btn-quantity minus-btn">-</span>
                          <input type="text" name="number" value="1">
                          <span class="btn-quantity plus-btn">+</span>
                      </div>
                  </div>
                  <div class="tf-product-info-buy-button">
                      <form class="">
                          <a href="javascript:void(0);"
                              class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn-add-to-cart"><span>Add
                                  to cart -&nbsp;</span><span class="tf-qty-price">$18.00</span></a>
                          <div class="tf-product-btn-wishlist btn-icon-action">
                              <i class="icon-heart"></i>
                              <i class="icon-delete"></i>
                          </div>
                          <a href="#compare" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft"
                              class="tf-product-btn-wishlist box-icon bg_white compare btn-icon-action">
                              <span class="icon icon-compare"></span>
                              <span class="icon icon-check"></span>
                          </a>
                          <div class="w-100">
                              <a href="#" class="btns-full">Buy with <img src="assets/images/payments/paypal.png" alt=""></a>
                              <a href="#" class="payment-more-option">More payment options</a>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal quick_add -->

  <!-- modal quick_view -->
  <div class="modal fade modalDemo" id="quick_view">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="wrap">
                  <div class="tf-product-media-wrap">
                      <div dir="ltr" class="swiper tf-single-slide">
                          <div class="swiper-wrapper">
                              <div class="swiper-slide">
                                  <div class="item">
                                      <img src="assets/assets/images/products/orange-1.jpg" alt="">
                                  </div>
                              </div>
                              <div class="swiper-slide">
                                  <div class="item">
                                      <img src="assets/assets/images/products/pink-1.jpg" alt="">
                                  </div>
                              </div>
                          </div>
                          <div class="swiper-button-next button-style-arrow single-slide-prev"></div>
                          <div class="swiper-button-prev button-style-arrow single-slide-next"></div>
                      </div>
                  </div>
                  <div class="tf-product-info-wrap position-relative">
                      <div class="tf-product-info-list">
                          <div class="tf-product-info-title">
                              <h5><a class="link" href="product-detail.html">Ribbed Tank Top</a></h5>
                          </div>
                          <div class="tf-product-info-badges">
                              <div class="badges text-uppercase">Best seller</div>
                              <div class="product-status-content">
                                  <i class="icon-lightning"></i>
                                  <p class="fw-6">Selling fast! 48 people have this in their carts.</p>
                              </div>
                          </div>
                          <div class="tf-product-info-price">
                              <div class="price">$18.00</div>
                          </div>
                          <div class="tf-product-description">
                              <p>Nunc arcu faucibus a et lorem eu a mauris adipiscing conubia ac aptent ligula
                                  facilisis a auctor habitant parturient a a.Interdum fermentum.</p>
                          </div>
                          <div class="tf-product-info-variant-picker">
                              <div class="variant-picker-item">
                                  <div class="variant-picker-label">
                                      Color: <span class="fw-6 variant-picker-label-value">Orange</span>
                                  </div>
                                  <div class="variant-picker-values">
                                      <input id="values-orange-1" type="radio" name="color-1" checked>
                                      <label class="hover-tooltip radius-60" for="values-orange-1"
                                          data-value="Orange">
                                          <span class="btn-checkbox bg-color-orange"></span>
                                          <span class="tooltip">Orange</span>
                                      </label>
                                      <input id="values-black-1" type="radio" name="color-1">
                                      <label class=" hover-tooltip radius-60" for="values-black-1" data-value="Black">
                                          <span class="btn-checkbox bg-color-black"></span>
                                          <span class="tooltip">Black</span>
                                      </label>
                                      <input id="values-white-1" type="radio" name="color-1">
                                      <label class="hover-tooltip radius-60" for="values-white-1" data-value="White">
                                          <span class="btn-checkbox bg-color-white"></span>
                                          <span class="tooltip">White</span>
                                      </label>
                                  </div>
                              </div>
                              <div class="variant-picker-item">
                                  <div class="d-flex justify-content-between align-items-center">
                                      <div class="variant-picker-label">
                                          Size: <span class="fw-6 variant-picker-label-value">S</span>
                                      </div>
                                      <div class="find-size btn-choose-size fw-6">Find your size</div>
                                  </div>
                                  <div class="variant-picker-values">
                                      <input type="radio" name="size-1" id="values-s-1" checked>
                                      <label class="style-text" for="values-s-1" data-value="S">
                                          <p>S</p>
                                      </label>
                                      <input type="radio" name="size-1" id="values-m-1">
                                      <label class="style-text" for="values-m-1" data-value="M">
                                          <p>M</p>
                                      </label>
                                      <input type="radio" name="size-1" id="values-l-1">
                                      <label class="style-text" for="values-l-1" data-value="L">
                                          <p>L</p>
                                      </label>
                                      <input type="radio" name="size-1" id="values-xl-1">
                                      <label class="style-text" for="values-xl-1" data-value="XL">
                                          <p>XL</p>
                                      </label>
                                  </div>
                              </div>
                          </div>
                          <div class="tf-product-info-quantity">
                              <div class="quantity-title fw-6">Quantity</div>
                              <div class="wg-quantity">
                                  <span class="btn-quantity minus-btn">-</span>
                                  <input type="text" name="number" value="1">
                                  <span class="btn-quantity plus-btn">+</span>
                              </div>
                          </div>
                          <div class="tf-product-info-buy-button">
                              <form class="">
                                  <a href="javascript:void(0);"
                                      class="tf-btn btn-fill justify-content-center fw-6 fs-16 flex-grow-1 animate-hover-btn btn-add-to-cart"><span>Add
                                          to cart -&nbsp;</span><span class="tf-qty-price">$8.00</span></a>
                                  <a href="javascript:void(0);"
                                      class="tf-product-btn-wishlist hover-tooltip box-icon bg_white wishlist btn-icon-action">
                                      <span class="icon icon-heart"></span>
                                      <span class="tooltip">Add to Wishlist</span>
                                      <span class="icon icon-delete"></span>
                                  </a>
                                  <a href="#compare" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft"
                                      class="tf-product-btn-wishlist hover-tooltip box-icon bg_white compare btn-icon-action">
                                      <span class="icon icon-compare"></span>
                                      <span class="tooltip">Add to Compare</span>
                                      <span class="icon icon-check"></span>
                                  </a>
                                  <div class="w-100">
                                      <a href="#" class="btns-full">Buy with <img src="assets/images/payments/paypal.png"
                                              alt=""></a>
                                      <a href="#" class="payment-more-option">More payment options</a>
                                  </div>
                              </form>
                          </div>
                          <div>
                              <a href="product-detail.html" class="tf-btn fw-6 btn-line">View full details<i
                                      class="icon icon-arrow1-top-left"></i></a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal quick_view -->

  <!-- modal find_size -->
  <div class="modal fade modalDemo tf-product-modal" id="find_size">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="header">
                  <div class="demo-title">Size chart</div>
                  <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
              </div>
              <div class="tf-rte">
                  <div class="tf-table-res-df">
                      <h6>Size guide</h6>
                      <table class="tf-sizeguide-table">
                          <thead>
                              <tr>
                                  <th>Size</th>
                                  <th>US</th>
                                  <th>Bust</th>
                                  <th>Waist</th>
                                  <th>Low Hip</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>XS</td>
                                  <td>2</td>
                                  <td>32</td>
                                  <td>24 - 25</td>
                                  <td>33 - 34</td>
                              </tr>
                              <tr>
                                  <td>S</td>
                                  <td>4</td>
                                  <td>34 - 35</td>
                                  <td>26 - 27</td>
                                  <td>35 - 26</td>
                              </tr>
                              <tr>
                                  <td>M</td>
                                  <td>6</td>
                                  <td>36 - 37</td>
                                  <td>28 - 29</td>
                                  <td>38 - 40</td>
                              </tr>
                              <tr>
                                  <td>L</td>
                                  <td>8</td>
                                  <td>38 - 29</td>
                                  <td>30 - 31</td>
                                  <td>42 - 44</td>
                              </tr>
                              <tr>
                                  <td>XL</td>
                                  <td>10</td>
                                  <td>40 - 41</td>
                                  <td>32 - 33</td>
                                  <td>45 - 47</td>
                              </tr>
                              <tr>
                                  <td>XXL</td>
                                  <td>12</td>
                                  <td>42 - 43</td>
                                  <td>34 - 35</td>
                                  <td>48 - 50</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div class="tf-page-size-chart-content">
                      <div>
                          <h6>Measuring Tips</h6>
                          <div class="title">Bust</div>
                          <p>Measure around the fullest part of your bust.</p>
                          <div class="title">Waist</div>
                          <p>Measure around the narrowest part of your torso.</p>
                          <div class="title">Low Hip</div>
                          <p class="mb-0">With your feet together measure around the fullest part of your hips/rear.
                          </p>
                      </div>
                      <div>
                          <img class="sizechart lazyload" data-src="assets/images/shop/products/size_chart2.jpg"
                              src="assets/images/shop/products/size_chart2.jpg" alt="">
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- /modal find_size -->

  <!-- Javascript -->

